import { debounce } from './utils.js'

export const initHptp = () => {
    // @ variables -----------------------
    const hptp_nav = document.querySelector('.js-hpt__nav')

    if (!hptp_nav) {
        return
    }

    const pos = {
        window: 0,
        nav: hptp_nav.getBoundingClientRect().top + window.scrollY,
        dist: 0,
        min_width: 1024,
        page_height: document.body.offsetHeight,
    }

    // @ functions -----------------------
    const handleScroll = () => {
        if (window.innerWidth < pos.min_width) return

        pos.window = window.scrollY
        pos.dist = pos.window - pos.nav
        hptp_nav.style.top = (pos.dist > 0 ? pos.dist + 10 : 0) + 'px'
    }

    const handleResize = () => {
        if (window.innerWidth < pos.min_width) {
            hptp_nav.style.top = 0 + 'px'
        }

        pos.nav = hptp_nav.offsetTop
    }

    const debouncedHandleScroll = debounce(handleScroll, 50)
    const debouncedHandleResize = debounce(handleResize, 50)

    // @ events -----------------------
    window.addEventListener('scroll', debouncedHandleScroll)
    window.addEventListener('resize', debouncedHandleResize)
}
